export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between mb-8 animate-fade-up">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tighter text-zinc-950" data-testid="page-title">
          {title}
        </h1>
        {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    active: { label: "Aktif", cls: "bg-green-50 text-green-700 border-green-200" },
    available: { label: "Müsait", cls: "bg-green-50 text-green-700 border-green-200" },
    rented: { label: "Kirada", cls: "bg-blue-50 text-blue-700 border-blue-200" },
    maintenance: { label: "Bakımda", cls: "bg-red-50 text-red-700 border-red-200" },
    overdue: { label: "Gecikmiş", cls: "bg-red-50 text-red-700 border-red-200" },
    completed: { label: "Tamamlandı", cls: "bg-zinc-100 text-zinc-600 border-zinc-200" },
    sold: { label: "Satıldı", cls: "bg-zinc-200 text-zinc-500 border-zinc-300" },
  };
  const s = map[status] || { label: status, cls: "bg-zinc-100 text-zinc-600 border-zinc-200" };
  return (
    <span className={`inline-flex items-center text-[11px] font-semibold px-2.5 py-0.5 rounded-full border ${s.cls}`}>
      {s.label}
    </span>
  );
}
